export enum DialogTipo {
    INFO = 'INFO', // informativo (un boton)
    CONFIRM = 'CONFIRM', // confirmacion (dos botones)
};